import { render } from "./DetailBium.vue?vue&type=template&id=896a9024&scoped=true"
import script from "./DetailBium.vue?vue&type=script&lang=js"
export * from "./DetailBium.vue?vue&type=script&lang=js"

import "./DetailBium.vue?vue&type=style&index=0&id=896a9024&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-896a9024"

export default script